import { render, staticRenderFns } from "./AffirmModal.vue?vue&type=template&id=37be3428&"
import script from "./AffirmModal.vue?vue&type=script&lang=js&"
export * from "./AffirmModal.vue?vue&type=script&lang=js&"
import style0 from "./AffirmModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports